import React from 'react';
import {analyticsTrack} from 'utilities/analytics';
import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';
import {FormattedMessage} from 'react-intl';
import Icon from 'components/Icon';
import InviteUserModal from 'components/InviteUserModal';
import './InviteUserItem.css';

class InviteUserItem extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {isOpen: false};

    this.handleRequestModalClose = this.handleRequestModalClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleInviteOpen = this.handleInviteOpen.bind(this);
    this.handleInviteSend = this.handleInviteSend.bind(this);
  }

  handleClick() {
    this.setState({
      isOpen: true,
    });
  }

  handleRequestModalClose() {
    this.setState({
      isOpen: false,
    });
  }

  handleInviteOpen() {
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.INVITE__OPEN_PEOPLE_SEARCH_HEADER);
  }

  handleInviteSend() {
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.INVITE__SUBMIT_PEOPLE_SEARCH_HEADER);
  }

  render() {
    return (
      <div className="InviteUserItem" onClick={this.handleClick}>
        <div className="InviteUserItem__Icon">
          <Icon icon={Icon.OPTIONS.PERSON_PLUS} size={Icon.SIZES.NANO} />
        </div>
        <div className="InviteUserItem__Text">
          <FormattedMessage
            id="InviteUserItem__Text"
            defaultMessage="Invite to Domo"
            description="Label for invite to Domo button"
          />
        </div>
        <InviteUserModal
          onRequestModalClose={this.handleRequestModalClose}
          isOpen={this.state.isOpen}
          onOpen={this.handleInviteOpen}
          onSend={this.handleInviteSend}
        />
      </div>
    );
  }
}

export default InviteUserItem;
